var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7428 12.2438C11.7428 12.2438 12.6744 16.7288 9.01275 16.7288C5.3511 16.7288 2.38275 14.7208 2.38275 12.2438C2.38275 9.76679 5.3511 7.75879 9.01275 7.75879C12.6744 7.75879 11.7428 12.2438 11.7428 12.2438Z",
    fill: "url(#paint0_linear_1_4748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.613 7.23828V22.9254C11.6129 23.0964 11.5706 23.2648 11.4899 23.4156C11.4091 23.5664 11.2925 23.695 11.1502 23.7899L9.72018 24.7428C9.58147 24.8353 9.42256 24.893 9.25685 24.9112C9.09114 24.9295 8.92348 24.9076 8.768 24.8474C8.61252 24.7873 8.47378 24.6906 8.36347 24.5656C8.25317 24.4406 8.17453 24.2909 8.13418 24.1292L6.41298 17.6383",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3179 18.2984C13.0786 17.6966 11.6129 17.6385 11.6129 17.6385H6.41289C5.03377 17.6385 3.71113 17.0906 2.73594 16.1154C1.76075 15.1402 1.21289 13.8176 1.21289 12.4385C1.21289 11.0593 1.76075 9.73669 2.73594 8.7615C3.71113 7.78631 5.03377 7.23846 6.41289 7.23846H11.6129C11.6129 7.23846 18.6914 6.95766 25.5034 1.24416C25.6549 1.11673 25.8396 1.03517 26.0358 1.00908C26.232 0.982982 26.4316 1.01343 26.6111 1.09684C26.7906 1.18025 26.9426 1.31316 27.0492 1.47996C27.1558 1.64675 27.2126 1.84051 27.2129 2.03846V22.8385C27.2128 23.0365 27.1562 23.2304 27.0497 23.3974C26.9432 23.5644 26.7913 23.6975 26.6117 23.7811C26.4321 23.8647 26.2324 23.8952 26.0361 23.8692C25.8398 23.8431 25.655 23.7616 25.5034 23.6341C24.0016 22.3742 22.4869 21.3784 21.0379 20.5915",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4748",
    x1: 7.11573,
    y1: 7.75879,
    x2: 7.11573,
    y2: 16.7288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestNews);
export default __webpack_public_path__ + "static/media/latest-news.6f06515df6aa8eee41a885d9da6023c5.svg";
export { ForwardRef as ReactComponent };